export const STORAGE_ROOT_KEY = 'ILS';
export const STORAGE_ROOT_DB = 'ILS_DB';
